import React, { ReactNode } from 'react';
import {InfoBlockItem} from './info.block.item.js';

// Interface for list items
interface InfoBlockListItem {
	id: string | number;
	text: string;
	value?: string | number;
}

// Interface for component props
interface InfoBlockProps {
	changePas?: boolean;
	fdRow?: boolean;
	jcCenter?: boolean;
	pgPrice?: boolean;
	list?: InfoBlockListItem[];
	children?: ReactNode;
}

export const InfoBlock = ( props: InfoBlockProps ) => {

	return(
		<div className={"info-block" +
			(props.changePas ? " change-pas-wrap" : " ") +
			(props.fdRow ? " fd-row" : " ")+
			(props.jcCenter ? " jc-center" : " ")+
			(props.pgPrice ? " pg-price" : " ")}>
		{
			(props.list || []).map( ( item: InfoBlockListItem ) => {
				return (
					<InfoBlockItem text={item.text} value={item.value} key={ item.id }>

					</InfoBlockItem>
				)
			})
		}

		{
			props.children
		}
		</div>
	);
};